import '../css/noticeBox.css'

export function SubHeader(message) {
    return (
            <p className='notice notSelectable'>{message}</p>
    );
}